import React, { useState } from "react";
import styles from "./index.module.less";
import { useRequest, useInterval } from "ahooks";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import api from "@/services";

function ImageryExtractionPanel() {
  const { t } = useTranslation();
  const [tasks, setTasks] = useState([]);
  const { run } = useRequest(api.getExtractionTasks, {
    manual: true,
    onSuccess: (result, params) => {
      setTasks(result);
    },
  });
  useInterval(
    () => {
      run();
    },
    5000,
    { immediate: true }
  );

  const items = tasks.map(({ id, date, status }) => {
    const p = ((status / 4) * 100).toFixed(0);
    let s = "active";
    if (status > 4) s = "exception";
    else if (status === 4) s = "success";

    return (
      <tr key={`order-item-${id}`}>
        {status === 4 ? (
          <td>
            <a
              href={`http://arcticroute.tpdc.ac.cn/geojson/images/${id}.png`}
              rel="noreferrer"
              className="ant-btn-link"
              style={{ cursor: "pointer" }}
              target="_blank"
            >
              {date}
            </a>
          </td>
        ) : (
          <td>{date}</td>
        )}
        <td>
          <Progress percent={100} size="small" status="success" />
        </td>
      </tr>
    );
  });
  return (
    <div className={styles.imageryExtractionPanel}>
      <Scrollbars style={{ width: "100%", height: "100%" }}>
        <table className="pure-table pure-table-striped">
          <thead>
            <tr>
              <th className="date">{t("startTime")}</th>
              <th className="status">{t("status")}</th>
            </tr>
          </thead>
          <tbody>{items}</tbody>
        </table>
      </Scrollbars>
    </div>
  );
}

export default ImageryExtractionPanel;
